'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = isString;
function isString(maybe) {
    return typeof maybe === 'string';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-custom-scrollbars/lib/utils/isString.js
// module id = 39
// module chunks = 0